import script from "./CourseCertificateHexagon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseCertificateHexagon.vue?vue&type=script&setup=true&lang=ts"

import "./CourseCertificateHexagon.vue?vue&type=style&index=0&id=0d71bf56&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d71bf56"]])

export default __exports__